import type { Data } from '@/api/api.ts'
import type { PhoneListOption } from '@/types/campaignTypes/campaign.types'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}phonelists/`

export const getPhonelistsChoices = async (campaignId: number): Promise<Data<PhoneListOption[]>> => {
  const params = { campaign_id: campaignId }

  return axios.get(`${urlPrefix}choices/`, { params })
}
